import { RcThemeInput } from '@ringcentral/juno';
import { overridesFactory } from '@/shared/theme/utils/overrides.factory';
import { paletteFactory } from '@/shared/theme/utils/palette.factory';

export const rcColor = '#066fac';

export const rcTheme: RcThemeInput = {
  palette: paletteFactory(rcColor),
  overrides: overridesFactory(rcColor),
};
